import { ethers } from 'ethers';
import { getProvider } from '../wallet';
import { queryLogs } from './common';
import { getTokenDetails } from '../common';
import { ACTIVE_DEPLOYMENT } from '../contracts/common';

// Contract Deplyoments
import RegistrarDeployment from '../../contracts/deployments/Registrar.json';

// Contract ABIs
import RegistrarABI from '../../contracts/abis/Registrar.json';

export const getApprovedTokens = async (): Promise<Token[]> => {
  const provider = getProvider();

  const logs = await queryLogs(
    RegistrarDeployment[ACTIVE_DEPLOYMENT].address,
    'TokenApproved(address,uint256)',
    [],
    RegistrarDeployment[ACTIVE_DEPLOYMENT].block,
  );

  const iface = new ethers.Interface(RegistrarABI);
  const latestTokenPrice = new Map<string, string[]>();

  logs.forEach(log => {
    const parsedLog = iface.parseLog(log);
    if (parsedLog?.args) {
      const [tokenAddress, basePrice] = parsedLog.args.map((arg: any) =>
        arg.toString(),
      );
      latestTokenPrice.set(tokenAddress, [tokenAddress, basePrice]);
    }
  });

  const argsArray: string[][] = Array.from(latestTokenPrice.values());

  const tokens = await Promise.all(
    argsArray.map(async obj => {
      const [tokenAddress, basePrice] = obj;
      const token = await getTokenDetails(tokenAddress, basePrice, provider);
      return token;
    }),
  );

  return tokens;
};
